<template>
  <div class="mc-table">
    <b-table
      :items="savedFilters"
      :fields="subFields"
      selectable
      select-mode="single"
      bordered
      show-empty
      responsive
      :selected="selectedRows"
      class="mc-table__content"
      @row-selected="onRowSelected"
    >
      <template #empty>
        <div class="text-center my-4">
          {{ $t('global.emptyTable') }}
        </div>
      </template>

      <template #thead-top>
        <tr>
          <th
            v-for="field in fields"
            :key="field.key"
            :rowspan="field.rowspan"
            :colspan="field.colspan"
          >
            {{ field.label }}
          </th>
        </tr>
      </template>
      <template #cell()="{ field, value, item }">
        <span v-if="field.key == 'status'">
          {{ checkDataStatus(item.value.activeFilters) }}
        </span>

        <span v-if="field.key == 'totalVehicle'" class="d-flex justify-content-between">
          {{
            item.value.activeFilters.licensePlate ? item.value.activeFilters.licensePlate.length : 0
          }}

          <div class="tooltip-wrapper">
            <i class="mc-icon icon-outline_eye vehicle_show-icon"></i>
            <div ref="tooltip" class="custom-tooltip">
              <div class="license-plate-grid">
                <span v-for="(plate, index) in item.value.activeFilters.licensePlate" :key="index">
                  {{ getLicensePlate(plate) }}
                </span>
              </div>
            </div>
          </div>
        </span>

        <span v-else>
          {{ value }}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    savedFilters: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    subFields: {
      type: Array,
      default: () => [],
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedRows: [],
    }
  },

  methods: {
    onRowSelected(rows) {
      this.selectedRows = rows
      this.$emit('selected-rows', rows)
    },

    checkDataStatus(data) {
      const motionStatus = data.motionStatus
      const keys = Object.keys(motionStatus).filter((key) => motionStatus[key] === true)
      const status = keys.map((item) => {
        if (item == 'all')
          return `${this.$t('global.filter.running')}, ${this.$t('global.filter.idle')}, ${this.$t(
            'global.filter.assisted'
          )}, ${this.$t('global.filter.parking')}, ${this.$t('global.filter.offline')}`
        else if (item == 'M') return this.$t('global.filter.running')
        else if (item == 'I') return this.$t('global.filter.idle')
        else if (item == 'A') return this.$t('global.filter.assisted')
        else if (item == 'P') return this.$t('global.filter.parking')
        else if (item == 'O') return this.$t('global.filter.offline')
      })
      if (status.length == 1) return status[0]
      else return status.join(', ')
    },

    getLicensePlate(id) {
      if (this.vehicles.length == 0) return ''

      const vehicles = this.vehicles.find((item) => item.id == id)
      return vehicles.licensePlate
    },

    showTooltip(event) {
      const tooltips = this.$refs.tooltip
      if (!tooltips || !tooltips.length) return

      const tooltip = event.target.nextElementSibling
      if (!tooltip) return

      const rect = event.target.getBoundingClientRect()
      tooltip.style.display = 'block'
      tooltip.style.position = 'absolute'
      tooltip.style.top = `${rect.bottom + 5}px`
      tooltip.style.left = `${rect.left}px`
    },

    hideTooltip() {
      if (this.$refs.tooltip) {
        this.$refs.tooltip.style.display = 'none'
      }
    },
  },
}
</script>

<style scoped lang="scss">
.mc-table {
  max-height: 500px;
  overflow: auto;
  max-width: 800px;
  &__content {
    border-collapse: collapse;
    :deep(th) {
      color: $mep-color-text-400;
      padding: 12px 16px;
      font-weight: 500;
      white-space: nowrap;
      background-color: #f8f9fa;
      border-bottom: 1px solid #dee2e6;
    }

    :deep(td) {
      color: $mep-color-text-400;
      padding: 12px 16px;
      vertical-align: middle;
      border-bottom: 1px solid #dee2e6;
    }

    :deep(tbody tr) {
      &:hover {
        background-color: $table-hover-color;
        cursor: pointer;
      }
    }

    :deep(thead tr) {
      border: 1px solid #dee2e6;
    }

    :deep(tr.b-table-row-selected) {
      background-color: #e9ecef !important;
    }

    .vehicle_show-icon {
      transition: all 0.2s ease;

      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }
    }
  }
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;

  &:hover {
    .custom-tooltip {
      display: block;
      position: fixed;
      max-height: 250px;
      overflow: hidden;
      overflow-y: auto;
    }
  }

  .custom-tooltip {
    display: none;
    background: white;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 4px;
    z-index: 9999;
    min-width: 200px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .license-plate-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
      gap: 8px;
    }
  }
}
</style>
